var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.75C7.35936 11.7498 8.43675 11.3784 9.31063 10.695L12.0581 13.4425L12.9419 12.5588L10.1944 9.81125C10.8781 8.93729 11.2497 7.85965 11.25 6.75C11.25 3.99313 9.00688 1.75 6.25 1.75C3.49313 1.75 1.25 3.99313 1.25 6.75C1.25 9.50688 3.49313 11.75 6.25 11.75ZM6.25 3C8.31812 3 10 4.68187 10 6.75C10 8.81812 8.31812 10.5 6.25 10.5C4.18187 10.5 2.5 8.81812 2.5 6.75C2.5 4.68187 4.18187 3 6.25 3Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13251 5.8663C7.36939 6.1038 7.50001 6.41755 7.50001 6.75005H8.75001C8.75057 6.42157 8.68601 6.09624 8.56006 5.79286C8.43412 5.48948 8.24929 5.21407 8.01626 4.98255C7.07001 4.03755 5.42939 4.03755 4.48376 4.98255L5.36626 5.86755C5.84126 5.3938 6.66001 5.39505 7.13251 5.8663Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/search-white.4c1040bc8d11493993ad0f4f0e69474b.svg";
export { ForwardRef as ReactComponent };